import { Button, Checkbox, DataSource, Layout, SearchPanel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutEscrowTransactionsList extends Layout {
    buttonCalculateInterest: Button;
    checkboxVoidedSearch: Checkbox;
    searchpanelEscrow: SearchPanel;
    sourceEscrowTransaction: DataSource;
    tableEscrowTransaction: Table;
    textboxAmountSearch: Textbox;
    textboxBatchCodeSearch: Textbox;
    textboxBatchNumberSearch: Textbox;
    textboxCheckDateSearch: Textbox;
    textboxCheckNumberSearch: Textbox;
    textboxDeductCodeSearch: Textbox;
    textboxEffectSearch: Textbox;
    textboxGlidSearch: Textbox;
    textboxIdSearch: Textbox;
    textboxPayeeIdSearch: Textbox;
}
